import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'sections/Resources/FreightTemplates/CommercialInvoice/components/SectionPurpose/SectionPurpose.module.scss';

const cn = classNames.bind(styles);

const SectionPurpose = (): ReactElement => {
  return (
    <section className={cn('purpose')}>
      <div className={cn('container')}>

        <div className={cn('purpose__section')}>

          <div className={cn('purpose__image-box')}>
            <picture>
              <source
                srcSet="
                /images/pages/Resources/FreightTemplates/sign-in.webp 1x,
                /images/pages/Resources/FreightTemplates/sign-in@2x.webp 2x
              "
                sizes="100vw"
              />
              <img
                className={cn('purpose__image')}
                src="/images/pages/Resources/FreightTemplates/sign-in.webp"
                alt="bill of lading"
              />
            </picture>
          </div>

          <div className={cn('purpose__content')}>
            <h2 className={cn('purpose__heading')}>
              <span> Why does the Commercial</span>{' '}
              <span> Invoice matter?</span>
            </h2>
            <p className={cn('purpose__paragraph')}>
              You need a "single source of truth" to keep the supply chain moving.
            </p>
            <ul className={cn('purpose__list')}>
              <li className={cn('purpose__list-item')}>
                <span>Customs Authorities:</span>{' '}
                They use it to assess duties and taxes. No invoice means no clearance.
              </li>
              <li className={cn('purpose__list-item')}>
                <span>Carriers:</span>{' '}
                They verify the description to ensure they aren't carrying undeclared dangerous goods.
              </li>
              <li className={cn('purpose__list-item')}>
                <span>Banks:</span>{' '}
                If you are trading under a Letter of Credit (LC), the bank will scrutinize every 
                comma on this invoice before releasing funds.
              </li>
              <li className={cn('purpose__list-item')}>
                <span>The Forwarder:</span>{' '}
                It gives you the raw data to file the Bill of Entry without having to guess.
              </li>
            </ul>
          </div>

        </div>

      </div>
    </section>
  );
};

export default SectionPurpose;